import { render, staticRenderFns } from "./RequisicaoComprometimentos.vue?vue&type=template&id=dbd661be"
import script from "./RequisicaoComprometimentos.vue?vue&type=script&lang=js"
export * from "./RequisicaoComprometimentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports